exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base_info .info_list[data-v-624de33a]{padding:20px 0}.base_info .info_list .tips[data-v-624de33a]{display:inline-table;padding-left:20px;font-style:italic;color:#666;font-size:12px}\n", ""]);

// exports
